import api from '../../../../api';

export const ToggleSelector = {
  INPUT: api.internals.ns.selector('toggle [type="checkbox"]')
};
